import { DownloadableData } from '@order-management/types';
import FileSaver from 'file-saver';

export const useXLSXDownload = () => {
  const downloadXLSX = (data: DownloadableData<number[]>) => {
    const byteArray = new Uint8Array(data.fileContent);
    const blob = new Blob([byteArray], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    FileSaver.saveAs(blob, data.fileName);
  };

  return { downloadXLSX };
};
